import React, {useContext, useEffect, useState} from 'react';
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import Slider from "react-slick";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faCity,
    faHourglass,
    faLocationDot,
    faPerson,
    faChildReaching
} from '@fortawesome/free-solid-svg-icons';
import {Link, useParams} from "react-router-dom";
import {handleDateFormat, handleImageUrl} from "../helpers";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { de } from 'date-fns/locale';
import {axios} from "../axios";
import {LangContext} from "../App";
import {Box, FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import { useNavigate } from 'react-router-dom';
import Seo from "../components/Seo/Seo";
import {getTranslation} from "../translations";
import { validateBookingParams, calculateTourPrice } from "../utils/bookingValidation";
import { checkDateAvailability, processAvailableDates } from "../utils/dateAvailability";
import { processImageString, updateSliderSettingsWithImages, createSliderImages } from "../utils/sliderUtils";


const TourPage = () => {
    const id = useParams().id
    const [data,setData] = useState()
    const lang = useContext(LangContext)
    const navigate = useNavigate();
    const [startDate, setStartDate] = useState(null);
    const [availableDateRanges,setAvailableDateRanges] = useState([
        {
            start: new Date(),
            end: new Date(),
        },
    ])
    const [sliderSettings,setSlidersettings] = useState({
        dots: true,
        infinite: true,
        speed: 500,
        arrows:false,
        slidesToShow: 1,
        slidesToScroll: 1,
        vertical:false,
        customPaging: (i) => <div style={{backgroundImage:`url(${i})`}}></div>,
    })
    const [guestCount,setGuestCount] = useState(0)
    const [childCount,setChildCount] = useState(0)
    const [selectedLanguage,setSelectedLanguage] = useState('')
    const [startingTime,setStartingTime] = useState('')
    useEffect(()=>{
        axios.get(`${lang}/private-tour/${id}`)
            .then(res => {
                setData(res.data)
            })
    },[id,lang])
    useEffect(()=>{
        const images = processImageString(data?.images);
        if(images.length > 0){
            const sliderData = updateSliderSettingsWithImages(sliderSettings, images);
            setSlidersettings(sliderData);
        }
        if(data?.available_dates){
            const ranges = processAvailableDates(data?.available_dates);
            if(ranges.length > 0) {
                setAvailableDateRanges(ranges);
            }
        }

    },[data])
    const handleDateChange = (date) => {
        setStartDate(date);
    };
    const isDateAvailable = (date) => {
        return checkDateAvailability(date, data, availableDateRanges);
    };
    const handleSliderImages = ()=>{
        return createSliderImages(data?.images, data?.title);
    }
    const handlePrice = ()=>{
        return calculateTourPrice(data, guestCount, childCount);
    }
    const handleBook = (url)=>{
        const t = (key) => getTranslation(lang, key);
        const validation = validateBookingParams(data, guestCount, childCount, selectedLanguage, startingTime, startDate, t);

        if (!validation.valid) {
            alert(validation.message);
            return;
        }

        navigate(url);
    }
    const handleLanguage = (event) => {
        setSelectedLanguage(event.target.value)
    };
    const handleStartingTime = (event) => {
        setStartingTime(event.target.value)
    };

    return (
        <div className='tour-page'>
            <Seo 
                pageKey="privateTours" 
                title={data?.title} 
                description={data?.description?.replace(/<[^>]*>?/gm, '').substring(0, 160)} 
            />
            <div className="center-wrapper">
                <main>
                    <div className="row w-100">
                        <div className="col-lg-8 p-1">
                            <div className="tour-info">
                                <div className="tour-image">
                                    <Slider {...sliderSettings}>
                                        {handleSliderImages()}
                                    </Slider>
                                </div>
                                <h1 className="tour-title">{data?.title}</h1>
                                <div className="tour-details-wrapper">
                                    <div className="row">
                                        <div className="col-6">
                                            {data?.region &&
                                            <p className='text-capitalize'>
                                                <div className='svg-wrapper'>
                                                    <FontAwesomeIcon icon={faLocationDot} className='me-3'/>
                                                </div>
                                                <b>{getTranslation(lang,'region')}:</b>
                                                {data?.region}
                                            </p>}
                                            {data?.city &&
                                            <p className='text-capitalize'>
                                                <div className='svg-wrapper'>
                                                    <FontAwesomeIcon icon={faCity} className='me-3'/>
                                                </div>
                                                <b>{getTranslation(lang,'city')}:</b>
                                                {data?.city}
                                            </p>}
                                        </div>
                                        <div className="col-6">
                                            <p>
                                                <div className='svg-wrapper'>
                                                    <FontAwesomeIcon icon={faHourglass} className='me-3'/>
                                                </div>
                                                <b>{getTranslation(lang,'tourDuration')}:</b>
                                                {data?.duration_day && <span className='me-1'>{`${data?.duration_day} ${getTranslation(lang,'day')}`}</span>}
                                                {data?.duration_hour && <span className='me-1'>{`${data?.duration_hour} ${getTranslation(lang,'hour')}`}</span>}
                                                {data?.duration_minute && <span className='me-1'>{`${data?.duration_minute} ${getTranslation(lang,'minute')}`}</span>}
                                            </p>
                                            <p>
                                                <div className='svg-wrapper'>
                                                    <FontAwesomeIcon icon={faLocationDot} className='me-3'/>
                                                </div>
                                                <b>{getTranslation(lang,'meetingPoint')}:</b> {data?.meeting}
                                                <br/>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="main-text" dangerouslySetInnerHTML={{__html:data?.text}}></div>
                            </div>
                        </div>
                        <div className="col-lg-4 p-1">
                            <div className="sidebar">
                                <div className="d-flex flex-column">
                                    <h5 className='mb-4  p-2 ps-3 bg-body rounded-3'>{getTranslation(lang, 'guestCount')}</h5>
                                    <div className="tour-details-wrapper mb-3">
                                        <p>
                                            <div className='svg-wrapper'>
                                                <FontAwesomeIcon icon={faPerson} className='me-3'/>
                                            </div>
                                            <b>{getTranslation(lang, 'price')}:</b> $ {data?.price}
                                        </p>
                                        <p>
                                            <div className='svg-wrapper'>
                                                <FontAwesomeIcon icon={faChildReaching} className='me-3'/>
                                            </div>
                                            <b>{getTranslation(lang, 'child')}:</b> $ {data?.child_price}
                                        </p>
                                    </div>
                                    <div className="d-flex flex-column">
                                        <div className='d-flex align-items-center mb-3'>
                                            <span className='me-3'>{getTranslation(lang, 'adults')}: &nbsp;</span>
                                            <input type="number"
                                                   value={guestCount}
                                                   min='1'
                                                   onChange={e => setGuestCount(Number(e.target.value))}
                                                   className='input-group w-25 ps-1 ms-2'
                                                   placeholder='0'/>
                                        </div>
                                        <div className='d-flex align-items-center'>
                                            <span className='me-3'>{getTranslation(lang, 'children')}:</span>
                                            <input type="number"
                                                   value={childCount}
                                                   min='1'
                                                   onChange={e => setChildCount(Number(e.target.value))}
                                                   className='input-group w-25 ps-1'
                                                   placeholder='0'/>
                                        </div>
                                    </div>
                                </div>
                                <Box sx={{ minWidth: 120,
                                    '& *':{
                                        textTransform:'capitalize'
                                    }
                                }} mt={2}>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">{getTranslation(lang, 'selectLanguage')}</InputLabel>
                                        <Select
                                            value={selectedLanguage}
                                            onChange={handleLanguage}
                                            label={getTranslation(lang, 'selectLanguage')}
                                        >
                                            {data?.languages && data.languages.split(',').map((e, idx)=>{
                                                return (
                                                    <MenuItem key={idx} value={e} sx={{textTransform:'capitalize'}}>{getTranslation(lang, e.trim().toLowerCase())}</MenuItem>
                                                )
                                            })}
                                        </Select>
                                    </FormControl>
                                </Box>
                                <Box sx={{ minWidth: 120 }} mt={2}>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">{getTranslation(lang, 'startingTime')}</InputLabel>
                                        <Select
                                            value={startingTime}
                                            onChange={handleStartingTime}
                                            label={getTranslation(lang, 'startingTime')}
                                        >
                                            {data?.starting_time && data.starting_time.split(';').map((e, idx)=>{
                                                return (
                                                    <MenuItem key={idx} value={e}>{e}</MenuItem>
                                                )
                                            })}
                                        </Select>
                                    </FormControl>
                                </Box>
                                <div className="d-flex mt-3 datePicker">
                                    <DatePicker
                                        selected={startDate}
                                        onChange={handleDateChange}
                                        inline
                                        minDate={new Date()}
                                        locale={lang === 'de' ? de : undefined}
                                        filterDate={(date) => isDateAvailable(date)}
                                    />
                                </div>
                                {data?.inclusions && <div className="d-flex flex-column">
                                    <h5 className='mb-4  p-2 ps-3 bg-body rounded-3 mt-4'>{getTranslation(lang, 'inclusions')}</h5>
                                    <ul className='inclusions-list'>
                                        {
                                            data?.inclusions.split(';').map((e, idx) => {
                                                return <li key={idx} className=' mb-2'>{e}</li>
                                            })
                                        }
                                    </ul>
                                </div>}
                                {data?.discount && <div><b>{getTranslation(lang, 'discount')}:</b> {data?.discount}%</div>}
                                <div className="d-flex flex-column mt-3">
                                    <h5>{getTranslation(lang, 'totalPrice')}:
                                        <span className='text-success'>
                                            {handlePrice()}
                                        </span>
                                    </h5>
                                </div>
                                <div onClick={()=> handleBook(`/booking/private-tour/${id}/${startDate && handleDateFormat(startDate)}/${handlePrice()}/${guestCount}/${childCount}/${selectedLanguage}/${startingTime}`)}
                                    className="btn btn-primary mt-3 w-100">{getTranslation(lang, 'bookNow')}</div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default TourPage;